module.exports = __webpack_public_path__ + "img/scan.6005b1ae.jpg";